import React from 'react'
import { BsLinkedin ,BsFillSendFill} from "react-icons/bs";

const Social = () => {
  return (
    <div className='home__social'>
        <a href="sumitkolipyaka99@gmail.com" className='home__social-icon' target='_blank'>
            <BsFillSendFill/>
        </a>

        <a href="https://www.linkedin.com/in/sumit-kolipyaka-226036226/" className='home__social-icon' target='_blank'>
        <BsLinkedin/>
        </a>

        <a href="https://github.com/SG-Kolipyaka" className='home__social-icon' target='_blank'>
            <i class="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social